module.exports = __webpack_public_path__ + "static/media/lu.36829aca.svg";